import { isDevelopment } from '@rst/libs-ts/src/utils/dev'

export const withBaseSiteUrl = (str: string) => {
	if (!str) return ''
	if (str.match(/^https?/g)) return str
	// if (isDevelopment) return `https://bazaavto888.ru${str}`
	// if (isDevelopment) return `https://mcom.rst.events${str}`
	// if (isDevelopment) return `https://hotplacevl.com/${str}`
	// if (isDevelopment) return `https://studio.rst.events/${str}`
	/* if (isDevelopment) return `https://bazaokean.ru${str}` */
	// if (isDevelopment) return `https://coliving.rst.events${str}`
	// if (isDevelopment) return `https://bo27.ru${str}`
	// if (isDevelopment) return `https://dubrovkaclub.ru${str}`
	// if (isDevelopment) return `https://smm-dlya-biznesa.rst.events${str}`
	// if (isDevelopment) return `https://novogodniy-voyagh.rst.events${str}`
	// if (isDevelopment) return `https://davidov.rst.events${str}`
	// if (isDevelopment) return `https://website-builder.rst.events${str}`
	// if (isDevelopment) return `https://partybusiness.rst.events${str}`
	// if (isDevelopment) return `https://studiosochi.rst.events${str}`
	// if (isDevelopment) return `https://invest.rsttur.ru${str}`
	// if (isDevelopment) return `https://white-place.ru${str}`
	// if (isDevelopment) return `https://uk.rsttur.ru${str}`
	// if (isDevelopment) return `https://intertours.rst.events${str}`
	// if (isDevelopment) return `https://investpark.rst.events${str}`
	if (isDevelopment) return `https://dacha-rst.ru${str}`

	if (isDevelopment) return `https://demo.bo25.ru${str}`
	return str
}
